import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  class: "tw-relative tw-w-full tw-text-xs",
  "data-testid": "chat-settings"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  d: "M19 9l-7 7-7-7"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 0,
  class: "tw-absolute tw-z-10 tw-mt-1 tw-max-h-60 tw-w-full tw-overflow-auto tw-rounded-lg tw-border tw-border-gray-200 tw-bg-white tw-shadow-lg"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "tw-text-xs tw-font-medium tw-text-gray-900" }
const _hoisted_7 = { class: "tw-text-2xs tw-text-gray-500" }

import { ref } from 'vue';

type Option = {
  value: any;
  label: string;
  description: string;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'StudioDetailedSelect',
  props: {
    options: {},
    selectedOption: {}
  },
  emits: ["onSelect"],
  setup(__props: any, { emit }) {

const props = __props;





const isOpen = ref(false);

function selectOption(option) {
  isOpen.value = false;
  emit('onSelect', option);
}

return (_ctx: any,_cache: any) => {
  const _directive_studio_click_outside = _resolveDirective("studio-click-outside")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "tw-flex tw-w-full tw-items-center tw-justify-between tw-rounded-lg tw-border tw-border-gray-300 tw-bg-white tw-px-4 tw-py-2 tw-text-left hover:tw-border-gray-400 focus:tw-outline-none",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (isOpen.value = !isOpen.value))
    }, [
      _createElementVNode("span", null, _toDisplayString(_ctx.selectedOption ? _ctx.selectedOption.label : 'Select an option'), 1),
      (_openBlock(), _createElementBlock("svg", {
        class: _normalizeClass(["tw-h-4 tw-w-4 tw-transform tw-text-gray-500 tw-transition-transform tw-duration-200", { 'tw-rotate-180': isOpen.value }]),
        fill: "none",
        stroke: "currentColor",
        "stroke-width": "2",
        viewBox: "0 0 24 24"
      }, _hoisted_3, 2))
    ]),
    (isOpen.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
            return (_openBlock(), _createElementBlock("div", {
              key: option.value,
              class: "tw-cursor-pointer tw-px-4 tw-py-2 tw-transition hover:tw-bg-gray-100",
              onClick: ($event: any) => (selectOption(option))
            }, [
              _createElementVNode("div", _hoisted_6, _toDisplayString(option.label), 1),
              _createElementVNode("div", _hoisted_7, _toDisplayString(option.description), 1)
            ], 8, _hoisted_5))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ])), [
    [_directive_studio_click_outside, () => (isOpen.value = false)]
  ])
}
}

})